import Sprite from '../Sprite';
import GameObject from '../../GameObject/GameObject';
import Point from '../../Utility/Point';
import Viewport from '../Viewport';

export default class WorldMap extends Viewport {
    protected onCreate(params: { backgrounds: string[] }) {
        super.onCreate(params);

        params.backgrounds.forEach((backgroundTexture, index) => {
            const backgroundSprite: Sprite = GameObject.Instantiate(Sprite, {
                texture: backgroundTexture,
                position: new Point(0, index * 1080),
                cullOffScreen: true,
                cullPadding: [0, 0, 1080, 1920],
            });
            this.addChild(backgroundSprite);
        });
    }
}
